module.exports = __webpack_public_path__ + "img/system44-mini.ff9f7253.png";